import { h, Component } from 'preact';
import style from './style';
import Portal from 'preact-portal';
import root from '@components/root';

let lastOpenedComponent;

class DropDownCard extends Component {
  getAnchorPosition = el => {
    const rect = el.getBoundingClientRect(),
      windowWidth = document ? document.body.clientWidth : 1280;

    return {
      windowWidth,
      left: rect.left + root.scrollX,
      top: rect.top + root.scrollY,
      bottom: rect.top + rect.height + root.scrollY,
      right: rect.left + rect.width + root.scrollX,
      xMiddle:
        rect.left - (Math.max(1680, windowWidth) - 1680) / 2 + rect.width / 2,
    };
  };
  scrollToPosition = el => {
    if (!el) {
      return;
    }
    root.setTimeout(() => {
      const rect = el.getBoundingClientRect();

      const windowBottom = root.innerHeight + root.scrollY;
      if (rect.bottom > windowBottom) {
        const top = Math.min(
          this.state.coordinates.top,
          rect.bottom - root.scrollY - rect.height
        );
        root.scrollTo({ top, behavior: 'smooth' });
      }
    }, 0);
  };

  componentWillReceiveProps({ anchor, show }) {
    if (show === true && this.props.show !== show) {
      if (
        lastOpenedComponent &&
        lastOpenedComponent.props &&
        lastOpenedComponent.props.show &&
        lastOpenedComponent.props.anchor !== anchor
      ) {
        if (lastOpenedComponent.props.onClose)
          lastOpenedComponent.props.onClose();
        lastOpenedComponent = this;
      }
      this.setState({ coordinates: this.getAnchorPosition(anchor) });
    }
  }
  render(props, state) {
    return props.show ? (
      <Portal into="body">
        <div
          class={style.dropDownWrapper}
          style={state.coordinates ? `top:${state.coordinates.bottom}px` : null}
          onMouseLeave={props.onClose}
        >
          <div class={`${style.dropDownSpacer} contain`}>
            <div class={style.dropDownCard}>
              <span
                class={style.dropDownArrow}
                style={`left: ${state.coordinates.xMiddle}px`}
              />
              <button class={style.closeButton} onClick={this.props.onClose}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="12"
                  viewBox="0 0 24 24"
                >
                  <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
                </svg>
              </button>
              <div ref={this.scrollToPosition}>{props.children}</div>
            </div>
          </div>
        </div>
      </Portal>
    ) : null;
  }
}
export default DropDownCard;



// WEBPACK FOOTER //
// ./components/dropdowncard/index.js